<template>
  <div id="nav-bar">
    <ul class="Polaris-Tabs pp-nav">
      <router-link
        v-for="(item, index) in tableList"
        :key="item.index"
        :to="item.path"
        custom
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li
          class="Polaris-Tabs__TabContainer"
          :class="{ active: isActive }"
          role="presentation"
        >
          <!--isExactActive 相当于严格匹配模式-->
          <!--必须得使用 item.path === $route.path 匹配，使用 isExactActive、isActive 会有问题-->
          <!--下面的 data-isActive data-isExactActive 没有意义，只是作为调试日坠查看-->
          <a
            :href="href"
            @click="navigate"
            :data-isActive="isActive"
            :data-isExactActive="isExactActive"
            :class="{
              'Polaris-Tabs__Tab': 1,
              'Polaris-Tabs__Tab--selected':
                item.urlStatus === $route.meta.urlStatus,
            }"
            role="tab"
            :tabindex="index"
          >
            <span
              v-if="item.title == 'Plan' && $store.state.packagType == 'Free'"
              class="Polaris-Tabs__Title Upsell_free_plan"
              >{{ item.title }}
              <span class="upsell_free_tip">Free</span>
            </span>

            <span v-else class="Polaris-Tabs__Title">{{ item.title }} </span>
          </a>
        </li>
      </router-link>
      <li
        class="Polaris-Tabs__TabContainer nav-extend"
        @click="subMenuOpen = !subMenuOpen"
        ref="subMenuWrap"
        :class="{ open: subMenuOpen }"
        role="presentation"
      >
        <a href="javascript:void(0)" role="tab" class="Polaris-Tabs__Tab">
          <span class="Polaris-Tabs__Title">
            <span class="Polaris-Icon">
              <svg
                viewBox="0 0 20 20"
                class="Polaris-Icon__Svg"
                focusable="false"
                aria-hidden="true"
              >
                <path
                  fill="#637381"
                  fill-rule="evenodd"
                  d="M6 10a2 2 0 1 1-4.001-.001A2 2 0 0 1 6 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 12 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 18 10z"
                ></path>
              </svg>
            </span>
          </span>
        </a>

        <ul class="pp-nav-extend">
          <li v-for="item in tableList" :key="item.index">
            <router-link
              :to="item.path"
              custom
              v-slot="{ href, navigate, isExactActive }"
            >
              <a
                :href="href"
                @click="navigate"
                :class="{ active: isExactActive }"
                role="tab"
              >
                {{ item.title }}
              </a>
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
    <div class="head-right">
      <polaris-button
        primary
        @click="next"
        class="paybtn"
        v-if="$store.state.pricingPlanId == 2"
      >
        Subscription plan
      </polaris-button>
      <a
        href="https://helpcenterapi.sealapps.com/help/app/article/3/46"
        target="_blank"
        >Help Center</a
      >
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: [
    'value',
    'activeIndex',
    'tableList'
  ],
  data () {
    return {
      activeTab: 0,
      subMenuOpen: false
    }
  },
  mounted () {
    let that = this;
    document.addEventListener('mouseup', (e) => {
      let tree = this.$refs.subMenuWrap
      if (tree) {
        if (!tree.contains(e.target)) {
          that.subMenuOpen = false
        }
      }
    })
  },
  methods: {
    // Mark 跳转至收费须知页面
    next() {
      this.$router.push({ name: "Plan" });
    }
  },
  watch: {
    activeTab () {
      this.$emit('change', this.activeTab);
    },
  }
};
</script>

<style scoped>
.head-right {
  display: flex;
  align-items: center;
  padding: 0 2rem;
}
.head-right a {
  color: #202223;
  font-weight: 600;
  font-size: 12px;
}
.head-right a::before {
  content: "";
  position: absolute;
  width: 33px;
  height: 2.8rem;
  background: url("../assets/icons/upsell/requestfill.png") 100% no-repeat;
  margin: -4px 0 0 -38px;
}
.paybtn {
  min-height: 24px;
  margin-right: 3rem;
  text-indent: 2rem !important;
}
.paybtn::before {
  content: "";
  position: absolute;
  width: 33px;
  height: 2.8rem;
  background: url("../assets/icons/upsell/Union.png") 100% no-repeat;
  margin: -4px 0 0 -14rem;
}
.upsell_free_tip {
  background: red;
  font-size: 1.4rem !important;
  color: #fff;
  position: absolute;
  top: -0.4rem;
  padding: 0.4px 9px !important;
  border-radius: 8px;
  transform: rotate(25deg);
  -ms-transform: rotate(25deg); /* IE 9 */
  -moz-transform: rotate(25deg); /* Firefox */
  -webkit-transform: rotate(25deg); /* Safari 和 Chrome */
  -o-transform: rotate(25deg);
}
.Upsell_free_plan {
  padding: 8px 40px !important;
}
.Polaris-Stack__Item {
  position: absolute;
  right: 50px;
  padding-top: 8px;
}
.Polaris-Tabs {
  flex-wrap: nowrap;
}
.pp-nav {
  flex: 1 1 auto;
}
.pp-nav li span {
  font-size: 1.6rem;
  padding: 8px 8px;
}
.nav-bar {
  border-bottom: 0.1rem solid #dfe3e8;
}
.nav-bar >>> li {
  margin: 0 1.2rem;
}

/*下卡菜单*/
.nav-extend {
  display: none;
}

#nav-bar {
  display: flex;
}

#nav-bar .nav-extend .Polaris-Tabs__Title {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
#nav-bar .pp-nav-extend {
  display: none;
  position: absolute;
  z-index: 80;
  top: 52px;
  min-width: 175px;
  text-shadow: none;
  border-radius: 4px;
  background: #fff;
  list-style: none;
  padding: 0.8rem 0;
  margin: 10px 0px 0px 0px;
  border: 1px solid #eee;
  box-shadow: 5px 5px rgb(102 102 102 / 10%);
  left: 15rem;
}

/*当出现 open 这个类名，就显示*/
.nav-extend.open .pp-nav-extend {
  display: block !important;
}

.nav-extend .Polaris-Tabs__Tab:focus .Polaris-Tabs__Title {
  border-bottom: unset;
}

.nav-extend.open .Polaris-Tabs__Tab:focus .Polaris-Tabs__Title {
  border-bottom: 0.3rem;
}

#nav-bar .pp-nav-extend li a {
  display: block;
  text-decoration: none;
  background-image: none;
  filter: none;
  padding: 8px 16px;
  color: #6f6f6f;
}

#nav-bar .pp-nav-extend li a.active,
#nav-bar .pp-nav-extend li a:hover {
  /* background-color: #5C6AC4;
  color: #fff; */
  border: 2px solid #458fff;
  border-radius: 8px;
}

#nav-bar a:hover {
  text-decoration: none;
}

#nav-bar .nav-extend a .Polaris-Icon {
  padding: 0;
}

.Polaris-Tabs__Tab:hover .Polaris-Tabs__Title::before {
  background-color: #008060;
}
.Polaris-Tabs__TabContainer {
  position: relative;
}

/*如果是最小屏幕的话，就直接把第一个菜单栏目隐藏的掉*/
/*@media screen and (max-width: 320px) {*/
/*  .Polaris-Tabs__TabContainer:first-child {*/
/*    display: none;*/
/*  }*/
/*}*/

@media (max-width: 767px) {
  /*把除了第一个元素，其他元素隐藏*/
  .Polaris-Tabs__TabContainer:not(:first-child) {
    display: none;
  }

  /*激活的元素设置为不隐藏*/
  .Polaris-Tabs__TabContainer.active {
    display: flex;
  }

  /*在移动端就显示该扩展菜单栏*/
  .Polaris-Tabs__TabContainer.nav-extend {
    display: flex;
  }
  .Upsell-help {
    display: none;
  }
}
.Polaris-Button {
  background-color: #377e62;
}
/* .Polaris-Button--plain {
  background-color: #fff;
  color: #4a85d3;
}
.Polaris-TextContainer {
  white-space: pre-line;
}  */
</style>

<style>
.Upsell-help .Polaris-Button a {
  background-color: #377e62;
  color: #fff;
}
.Upsell-help .Polaris-Button:hover {
  /* background: var(--p-action-secondary-hovered); */
  background-color: #377e62;
}
</style>
